import API_ROUTES from "../constants/api";
import { DEFAULT_ITEMS_PER_PAGE } from "../constants/common";
import HttpUtil from "../http-handler/http-util";

export default class SadminSubscriptionService {
  static getList(pageNumber = 0, pageSize = DEFAULT_ITEMS_PER_PAGE, key='') {
    return HttpUtil.get(API_ROUTES.SUPERADMINSUBSCRIPTION.LIST.replace("<pageNumber>", pageNumber)
    .replace("<pageSize>", pageSize)
    .replace("<key>", key));
  }

  static getRegulations(forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.get(API_ROUTES.SUPER_ADMIN_STD.GET_PUBLISHED_REGULATIONS);
    } else {
      return HttpUtil.get(API_ROUTES.SUPERADMINSUBSCRIPTION.REGULATIONS);
    }    
  }

  static onSubmit(id,params) {
    var url = API_ROUTES.SUPERADMINSUBSCRIPTION.SUBMIT;
    if(id!=null) {
        url+='/'+id;
        return HttpUtil.put(url,params);
    } else {
        return HttpUtil.post(url,params);   
    }     
  }
 
}